<app-side-menu>
  <div class="approval-content">
    <!-- Header -->
    <div class="row mb-4" *ngIf="!isLoading && vehicleRental">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <app-button 
                text="Voltar"
                color="var(--secondary-color)"
                (buttonClick)="cancel()"
                className="me-3">
                <i class="fas fa-arrow-left me-2"></i>
              </app-button>
              <div>
                <h1 class="page-title">
                  <i class="fas fa-gavel me-3"></i>
                  Aprovação de Locação
                </h1>
                <p class="page-subtitle mb-0">Revisar e aprovar/rejeitar locação</p>
              </div>
            </div>
            <div class="rental-info">
              <span class="badge" [ngClass]="getStatusClass(vehicleRental.status)">
                {{ vehicleRental.status }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <app-loading [show]="isLoading" message="Carregando dados da locação..."></app-loading>

    <!-- Content -->
    <div *ngIf="!isLoading && vehicleRental" class="row">
      <div class="col-12">
        <div class="approval-card">
          <!-- Rental Summary -->
          <div class="rental-summary mb-4">
            <h4 class="mb-3">
              <i class="fas fa-file-contract me-2"></i>
              Locação {{ vehicleRental.rentalNumber }}
            </h4>
            <div class="summary-grid">
              <div class="summary-item">
                <label>Cliente:</label>
                <span>{{ vehicleRental.customerName || 'Não informado' }}</span>
              </div>
              <div class="summary-item">
                <label>Motorista:</label>
                <span>{{ vehicleRental.driverName || 'Não informado' }}</span>
              </div>
              <div class="summary-item">
                <label>Período:</label>
                <span>{{ formatDate(vehicleRental.startDate) }} até {{ formatDate(vehicleRental.endDate) }}</span>
              </div>
            </div>
          </div>

          <!-- Approval Form -->
          <form [formGroup]="approvalForm" (ngSubmit)="onSubmit()">
            <div class="approval-section">
              <h5 class="section-title">
                <i class="fas fa-gavel me-2"></i>
                Decisão de Aprovação
              </h5>

              <div class="row g-3">
                <!-- Action Selection -->
                <div class="col-md-6">
                  <label class="form-label">Ação *</label>
                  <div class="action-selection">
                    <div class="form-check">
                      <input
                        type="radio"
                        id="approve"
                        formControlName="action"
                        value="approve"
                        class="form-check-input">
                      <label for="approve" class="form-check-label approve-label">
                        <i class="fas fa-check-circle me-2"></i>
                        Aprovar Locação
                      </label>
                    </div>
                    <div class="form-check mt-2">
                      <input
                        type="radio"
                        id="reject"
                        formControlName="action"
                        value="reject"
                        class="form-check-input">
                      <label for="reject" class="form-check-label reject-label">
                        <i class="fas fa-times-circle me-2"></i>
                        Rejeitar Locação
                      </label>
                    </div>
                  </div>
                </div>

                <!-- Approval Level (only when approving) -->
                <div class="col-md-6" *ngIf="approvalForm.get('action')?.value === 'approve'">
                  <label for="approvalLevel" class="form-label">Nível de Aprovação</label>
                  <select id="approvalLevel" class="form-select" formControlName="approvalLevel">
                    <option value="">Selecione</option>
                    <option value="Supervisor">Supervisor</option>
                    <option value="Gerente">Gerente</option>
                    <option value="Diretor">Diretor</option>
                  </select>
                </div>

                <!-- Comments -->
                <div class="col-12">
                  <label for="comments" class="form-label">Comentários</label>
                  <textarea
                    id="comments"
                    class="form-control"
                    formControlName="comments"
                    rows="4"
                    placeholder="Adicione comentários sobre sua decisão..."></textarea>
                  <small class="form-text text-muted">Máximo 500 caracteres</small>
                </div>

                <!-- Conditions (only when approving) -->
                <div class="col-12" *ngIf="approvalForm.get('action')?.value === 'approve'">
                  <label for="conditions" class="form-label">Condições de Aprovação</label>
                  <textarea
                    id="conditions"
                    class="form-control"
                    formControlName="conditions"
                    rows="3"
                    placeholder="Condições especiais para aprovação (opcional)..."></textarea>
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="action-buttons">
              <app-button 
                text="Cancelar"
                color="#6c757d"
                (buttonClick)="cancel()">
                <i class="fas fa-times me-2"></i>
              </app-button>
              
              <app-button 
                [text]="isSubmitting ? 'Enviando...' : 'Enviar Decisão'"
                color="#198754"
                type="submit"
                [disabled]="isSubmitting || !approvalForm.valid">
                <i class="fas fa-paper-plane me-2" *ngIf="!isSubmitting"></i>
                <span class="spinner-border spinner-border-sm me-2" *ngIf="isSubmitting"></span>
              </app-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
